var shapes = require('inc/shapes');
var utils = require('utils');

module.exports = function(xyPair,r,n,color,ro){
  return this.poly(shapes.ngon(n).scale(r).rotate(ro).translate(xyPair),color);
};